var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-button-create",on:{"click":_vm.create}},[_vm._v("\n  自動承認イベントの作成\n")])}
var staticRenderFns = []

export { render, staticRenderFns }